import React, { useEffect, useState } from "react";
import axios from "../../api/axios";

// MUI components
import { Grid, Paper, Typography, MenuItem, Select, InputLabel, FormControl } from "@mui/material";

// Custom components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function CadreDetails() {
  const [cadres, setCadres] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [details, setDetails] = useState(null);

  // Fetch cadres on mount
  const fetchCadres = async () => {
    try {
      const res = await axios.get("/cadres");
      setCadres(res.data);
    } catch (error) {
      console.error("Failed to fetch cadres:", error);
    }
  };

  useEffect(() => {
    fetchCadres();
  }, []);

  // Fetch cadre details on change
  useEffect(() => {
    if (selectedId) {
      axios
        .post("/cadre/details", { cadre_id: selectedId })
        .then((res) => setDetails(res.data))
        .catch(() => setDetails(null));
    } else {
      setDetails(null);
    }
  }, [selectedId]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={2} px={2} py={4}>
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            variant="outlined"
            sx={{
              backgroundColor: "#ffffff",
              borderRadius: 3,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                "& fieldset": {
                  borderColor: "#d0d7de",
                },
                "&:hover fieldset": {
                  borderColor: "#1976d2",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#1976d2",
                  borderWidth: "2px",
                },
              },
              mt: 1,
            }}
          >
            <InputLabel id="cadre-select-label">Select Cadre</InputLabel>
            <Select
              labelId="cadre-select-label"
              value={selectedId}
              onChange={(e) => setSelectedId(e.target.value)}
              label="Select Cadre"
              sx={{
                height: 50,
                fontSize: "1rem",
              }}
            >
              <MenuItem value="">
                <em>-- Select --</em>
              </MenuItem>
              {cadres.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        {details && (
          <Grid item xs={12}>
            <Paper
              elevation={4}
              sx={{
                p: 4,
                mt: 4,
                borderRadius: 3,
                background: "#fff",
                boxShadow: "0 8px 16px rgba(0,0,0,0.08)",
              }}
            >
              <Typography variant="h5" mb={2} color="primary">
                Cadre Details
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Cadre Name:
                  </Typography>
                  <Typography variant="body1">{details.cadre_name}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Grade Level:
                  </Typography>
                  <Typography variant="body1">{details.grade_level}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Salary Structure:
                  </Typography>
                  <Typography variant="body1">{details.salary_structure}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Staff Group:
                  </Typography>
                  <Typography variant="body1">{details.staff_group}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography variant="subtitle2" color="textSecondary">
                    Amount:
                  </Typography>
                  <Typography variant="body1" fontWeight="bold" color="green">
                    ₦{Number(details.amount).toLocaleString()}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
      </Grid>
      <Footer />
    </DashboardLayout>
  );
}

export default CadreDetails;
